import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    BarController,
    LineElement,
    LineController,
    PointElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    ChartData,
    ChartOptions,
    Plugin,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { forwardRef } from 'react';
import ResponsiveChartContainer from './ResponsiveChartContainer';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    BarController,
    LineElement,
    LineController,
    PointElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

export interface MixedChartProps {
    type: 'bar' | 'line' | 'mixed';
    data: ChartData<'bar' | 'line'>;
    options?: ChartOptions<'bar' | 'line'>;
    plugins?: Plugin<'bar' | 'line'>[];
    testId?: string;
    fixedHeight?: boolean;
    minHeight?: number;
    maxHeight?: number;
    heightPx?: number;
}

const MixedChart = forwardRef<
    ChartJS<'bar' | 'line'> | undefined,
    MixedChartProps
>(function MixedChart(
    {
        type,
        data,
        options,
        plugins,
        testId,
        fixedHeight = true,
        minHeight = 300,
        maxHeight = 700,
        heightPx = 500,
    },
    ref
) {
    const chartOptions = {
        ...options,
        maintainAspectRatio: false,
    };

    const chartType = type === 'mixed' ? 'bar' : type;

    if (fixedHeight) {
        return (
            <div className="w-full" style={{ height: `${heightPx}px` }}>
                <Chart
                    ref={ref}
                    type={chartType}
                    data={data}
                    options={chartOptions}
                    plugins={plugins}
                    data-testid={testId ?? `${type}-chart`}
                />
            </div>
        );
    }

    return (
        <ResponsiveChartContainer
            minHeight={minHeight}
            maxHeight={maxHeight}
            testId={`${testId ?? `${type}-chart`}-container`}
        >
            <Chart
                ref={ref}
                type={chartType}
                data={data}
                options={chartOptions}
                plugins={plugins}
                data-testid={testId ?? `${type}-chart`}
            />
        </ResponsiveChartContainer>
    );
});

export default MixedChart;
